export const getMouseLocation = (e, stage) => {
  const transform = stage.getAbsoluteTransform().copy()
  transform.invert()
  const pos = stage.getPointerPosition()
  return transform.point(pos)
}



// WEBPACK FOOTER //
// ./src/components/schemaFonctionnel/helper/getMouseLocation.js